// ============================================================
// Primitive 13 — SourceDot, la pastille de provenance.
// ------------------------------------------------------------
// C'est le point où l'interface d'AGC ne tenait pas la promesse du
// projet. Le code y respectait « l'IA propose, l'humain décide » ;
// l'interface, elle, écrasait silencieusement les temps saisis au
// clic sur « Pré-chiffrer », sans marquer d'où venait chaque valeur
// ni permettre de revenir en arrière.
//
// Ici, chaque champ chiffré porte sa provenance. La pastille est
// posée dès la phase 1 pour que la phase 3 n'ait qu'à la remplir.
// ============================================================

const SOURCES = {
  manual: { label: 'Saisi par vous' },
  plan: { label: 'Lu sur le plan' },
  ai: { label: 'Proposé par l’IA' },
  history: { label: "Repris d'un devis passé" },

  // ── La provenance d'une valeur MATIÈRE — §2.5 ──
  //
  // Elle répond à une autre question que les quatre précédentes. Celles-là
  // disent QUI a écrit la valeur ; celles-ci disent À QUEL POINT ON PEUT
  // S'Y FIER. C'est ce qui permet à Charles de savoir en un coup d'œil où
  // porter son attention au lieu de tout revérifier — et c'est exactement
  // ce que la première mesure de fiabilité a validé sur la confiance de
  // l'agent 1 (CLAUDE.md §7).
  //
  // `saisi` porte une pastille BLEUE, là où `manual` n'en porte aucune. Ce
  // n'est pas une incohérence : sur un champ ordinaire, l'absence de marque
  // dit « c'est vous ». Sur la matière, quatre provenances coexistent et
  // l'une d'elles est la vôtre — ne rien afficher la rendrait
  // indiscernable d'une valeur non encore résolue.
  referentiel: { label: 'Référentiel Mertens, confirmé' },
  offre: { label: 'Offre fournisseur' },
  web: { label: 'Trouvé en ligne — à vérifier' },
  estime: { label: 'Estimé par famille — à confirmer' },
  saisi: { label: 'Saisi à la main' },
  aucune: { label: 'Aucune valeur disponible' },
};

export function SourceDot({ source = 'manual', title }) {
  const meta = SOURCES[source] ?? SOURCES.manual;
  // Une valeur saisie par l'humain n'a PAS de pastille : c'est la
  // valeur de référence, et l'absence de marque est l'information.
  if (source === 'manual' || !source) return null;
  return (
    <span
      className={`source-dot source-dot--${source}`}
      title={title ?? meta.label}
      role="img"
      aria-label={title ?? meta.label}
    />
  );
}

export default SourceDot;
